import SearchBar from './SearchBar';
import DEALS from '../data/deals';

/**
 * Sticky top header: logo + search bar + live-deal counter.
 * @param {{ search: string, onSearch: (val: string) => void }} props
 */
const Header = ({ search, onSearch }) => (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-slate-100 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3">
            <div className="flex items-center gap-4">
                {/* Logo */}
                <a
                    href="/"
                    aria-label="DealsNDiscounts home"
                    className="flex items-center gap-2.5 shrink-0 group"
                >
                    <div
                        className="w-9 h-9 bg-gradient-to-br from-brand-600 to-violet-600 rounded-xl
            flex items-center justify-center shadow-md shadow-brand-200
            group-hover:shadow-lg group-hover:shadow-brand-300 transition-shadow"
                    >
                        <span
                            className="text-white text-lg leading-none"
                            aria-hidden="true"
                        >
                            ⚡
                        </span>
                    </div>
                    <div className="hidden sm:block leading-none">
                        <div className="text-lg font-display font-extrabold text-slate-900 tracking-tight">
                            DealsNDiscounts
                        </div>
                        <div className="text-xs text-brand-500 font-semibold mt-0.5">
                            Best Deals Daily
                        </div>
                    </div>
                </a>

                {/* Search */}
                <SearchBar
                    value={search}
                    onChange={onSearch}
                />

                {/* Live deal counter */}
                <div className="hidden md:flex shrink-0">
                    <span
                        className="inline-flex items-center gap-1.5 text-xs text-slate-500 font-medium
            bg-slate-50 border border-slate-200 px-3 py-1.5 rounded-full"
                    >
                        <span
                            className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse-slow"
                            aria-hidden="true"
                        />
                        {DEALS.length} live deals
                    </span>
                </div>
            </div>
        </div>
    </header>
);

export default Header;
